"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var oneProductResultWithoutFilters = function oneProductResultWithoutFilters(_ref) {
  var totalCount = _ref.totalCount,
    products = _ref.products,
    filtersData = _ref.filtersData;
  var oneProduct = typeof window !== "undefined" && totalCount === 1 && (products === null || products === void 0 ? void 0 : products.length) === 1;
  if (!oneProduct) {
    return;
  }
  var withoutFilters = !filtersData.some(function (filter) {
    return filter.value;
  });
  return oneProduct && withoutFilters;
};
var _default = oneProductResultWithoutFilters;
exports["default"] = _default;